import React, { useState, useMemo, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from 'react-hook-form';
// import { useTheme } from '@material-ui/styles';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  Tabs,
  Tab,
  Button,
} from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import { useIntl } from 'umi';
import DateRangePickerML from '@/components/DateRangePickerML';
import AutoComplateML from '@/components/AutoComplateML';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import ClearIconML from '@/components/ClearIconML/index';
import SearchGroupStyled from './SearchGroupStyled';
import { orderSourceMapList } from '@/constants';
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const SearchGroup = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { query, tabValue, setTabValue } = props;
  const { handleSearch, restClick, searchRef } = props;
  const [isReset, setIsReset] = React.useState(false);
  const [orderNoStatus, setOrderNoStatus] = React.useState(false);
  const [memberCodeStatus, setMemberCodeStatus] = React.useState(false);
  const [mobileStatus, setMobileStatus] = React.useState(false);
  const {
    orderNo,
    orderType,
    channel,
    memberCode,
    mobile,
    startDate,
    endDate,
    // store,
    store: RegisterStore,
  } = query;

  const { handleSubmit, control, reset, setValue, getValues, watch } = useForm({
    defaultValues: {
      orderNo,
      orderType,
      channel,
      memberCode,
      mobile,
      // store,
      date: { startDate: startDate, endDate: endDate },
    },
  });

  const watchAllFields = watch();

  useEffect(() => {
    if (watchAllFields.orderNo) {
      setOrderNoStatus(true);
    } else {
      setOrderNoStatus(false);
    }
    if (watchAllFields.memberCode) {
      setMemberCodeStatus(true);
    } else {
      setMemberCodeStatus(false);
    }
    if (watchAllFields.mobile) {
      setMobileStatus(true);
    } else {
      setMobileStatus(false);
    }
  }, [
    watchAllFields.orderNo,
    watchAllFields.memberCode,
    watchAllFields.mobile,
  ]);

  //订单类型
  const typeList = [
    {
      name: formatMessage({ id: 'order.order.c01.lbl11' }),
      value: 'SALE_ORDER',
    },
    {
      name: formatMessage({ id: 'order.order.c01.lbl12' }),
      value: 'REFUND_RETURN',
    },
  ];

  const [rsValue, setRsValue] = useState([]);

  const defaultRegisterStore = useMemo(() => {
    let RegisterStoreArray = [];
    if (RegisterStore) {
      RegisterStoreArray = RegisterStore.split('-');
    }
    return RegisterStoreArray;
  }, [RegisterStore]);

  const handleRestClick = () => {
    const resetSearch = {
      orderNo: '',
      orderType: '',
      channel: '',
      memberCode: '',
      mobile: '',
      startDate: null,
      endDate: null,
      store: '',
      initTabValue: 0,
    };
    setIsReset(true);
    reset(resetSearch);
    restClick && restClick(resetSearch);
  };
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleSubmitSuccess = (submitData) => {
    const registerStore = rsValue?.join('-');
    const propsSubmitData = {
      ...submitData,
      store: registerStore,
    };
    handleSearch && handleSearch(propsSubmitData);
  };
  console.log(11111, getValues('orderNo'));
  return (
    <SearchGroupStyled>
      <Box
        sx={{ backgroundColor: '#fff', borderRadius: '12px' }}
        p={3}
        pt={1}
        mb={0.5}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={4}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="basic tabs"
          >
            <Tab
              label={formatMessage({ id: 'order.order.n01.lbl01' })}
              sx={{ fontSize: '16px' }}
              {...a11yProps(0)}
            />
            <Tab
              label={formatMessage({ id: 'order.order.n01.lbl03' })}
              sx={{ fontSize: '16px' }}
              {...a11yProps(1)}
            />
            <Tab
              label={formatMessage({ id: 'order.order.n01.lbl06' })}
              sx={{ fontSize: '16px' }}
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>
        <Box>
          <form onSubmit={handleSubmit(handleSubmitSuccess)}>
            <Box className="search-wrapper">
              <Box className="left">
                <Box className="first-line">
                  {tabValue === 0 && (
                    <Controller
                      variant="standard"
                      as={TextField}
                      name="orderNo"
                      control={control}
                      id="basic"
                      className="input"
                      label={formatMessage({ id: 'order.order.n01.lbl02' })}
                      defaultValue={''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              className="clear-btn"
                              onClick={() => {
                                setValue('orderNo', '');
                              }}
                              edge="end"
                            >
                              {orderNoStatus ? (
                                <ClearIcon className="clear-icon" />
                              ) : (
                                ''
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                  {tabValue === 1 && (
                    <Controller
                      variant="standard"
                      as={TextField}
                      name="memberCode"
                      control={control}
                      id="basic"
                      className="input"
                      label={formatMessage({ id: 'order.order.n01.lbl04' })}
                      defaultValue={''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              className="clear-btn"
                              onClick={() => {
                                setValue('memberCode', '');
                              }}
                              edge="end"
                            >
                              {memberCodeStatus ? (
                                <ClearIcon className="clear-icon" />
                              ) : (
                                ''
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                  {tabValue === 1 && (
                    <Controller
                      variant="standard"
                      as={TextField}
                      name="mobile"
                      control={control}
                      id="basic"
                      className="input"
                      label={formatMessage({ id: 'order.order.n01.lbl05' })}
                      defaultValue={''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              className="clear-btn"
                              onClick={() => {
                                setValue('mobile', '');
                              }}
                              edge="end"
                            >
                              {mobileStatus ? (
                                <ClearIcon className="clear-icon" />
                              ) : (
                                ''
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                  {tabValue === 2 && (
                    <FormControl
                      variant="standard"
                      className="channel single-select"
                    >
                      <InputLabel>
                        {formatMessage({ id: 'order.order.n01.rdo07' })}
                      </InputLabel>
                      <Controller
                        as={
                          <Select className="select">
                            {typeList.map((item) => (
                              <MenuItem
                                key={item.value}
                                value={item.value}
                                name={item.value}
                              >
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                        }
                        label={formatMessage({ id: 'order.order.n01.rdo07' })}
                        name="orderType"
                        placeholder=""
                        variant="standard"
                        defaultValue={''}
                        control={control}
                      />
                      <ClearIconML
                        handleClick={() => {
                          setValue('orderType', '');
                        }}
                        clearValue={watchAllFields?.orderType}
                      ></ClearIconML>
                    </FormControl>
                  )}

                  {tabValue === 2 && (
                    <FormControl
                      variant="standard"
                      className="gender single-select"
                    >
                      <InputLabel>
                        {formatMessage({ id: 'order.order.n01.rdo08' })}
                      </InputLabel>
                      <Controller
                        as={
                          <Select className="select">
                            {orderSourceMapList.map((item) => (
                              <MenuItem
                                key={item.id}
                                value={item.id}
                                name={item.id}
                              >
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                        }
                        label={formatMessage({ id: 'order.order.n01.rdo08' })}
                        name="channel"
                        defaultValue={''}
                        variant="standard"
                        control={control}
                      />
                      <ClearIconML
                        handleClick={() => {
                          setValue('channel', '');
                        }}
                        clearValue={watchAllFields?.channel}
                      ></ClearIconML>
                    </FormControl>
                  )}
                  {tabValue === 2 && (
                    <FormControl variant="standard">
                      <Controller
                        render={(rp) => (
                          <DateRangePickerML
                            label={formatMessage({
                              id: 'order.order.c01.lbl07',
                            })}
                            title={formatMessage({
                              id: 'order.order.c01.lbl07',
                            })}
                            startText={formatMessage({
                              id: 'order.order.n01.rdo09',
                            })}
                            endText={formatMessage({
                              id: 'order.order.n01.rdo10',
                            })}
                            defaultStartDate={startDate ? startDate : null}
                            defaultEndDate={endDate ? endDate : null}
                            rp={rp}
                            setValue={setValue}
                            onChange={() =>
                              // {
                              //  startDate, endDate, reset
                              //  }
                              {
                                setIsReset(false);
                              }
                            }
                            name="custom-form-submit-name"
                            isReset={isReset}
                          />
                        )}
                        name="date"
                        control={control}
                      />
                    </FormControl>
                  )}
                  {tabValue === 2 && 1 === 0 ? (
                    // <Controller
                    //   variant="standard"
                    //   as={TextField}
                    //   name="store"
                    //   control={control}
                    //   id="basic"
                    //   className="input"
                    //   label="门店ID"
                    //   defaultValue={''}
                    // />
                    <AutoComplateML
                      label={formatMessage({ id: 'order.order.n01.chb11' })}
                      defaultValue={defaultRegisterStore}
                      selectedId={rsValue}
                      setSelectedId={setRsValue}
                    />
                  ) : (
                    <div></div>
                  )}
                </Box>
              </Box>
              <Box className="button-group">
                <Button
                  variant="contained"
                  color="secondary"
                  className="reset"
                  startIcon={
                    <ReplayIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={
                    handleRestClick
                    // reset({
                    //   title: '',
                    //   type: '',
                    //   usedType: '',
                    //   status: '',
                    // })
                  }
                >
                  {formatMessage({ id: 'order.order.n01.btn12' })}
                </Button>

                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_online_store_order_management_list_search',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  ref={searchRef}
                  variant="contained"
                  type="submit"
                  className="search"
                  startIcon={
                    <SearchIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  {formatMessage({ id: 'order.order.c01.lbl15' })}
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </Box>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
